export const WorkData = [
  {
    id: 1,
    name: "Power Card",
    description:
      "An online store for displaying and selling electronic and virtual cards for game stores and recharge cards for games and Playstation",
    tags: ["NextJs", "ReactJs", "Hooks", "REST-API", "Redux", "SwiperJs"],

    demo: "http://power-card-tau.vercel.app/",
    github: "https://github.com/ahmedatif99",
  },
  {
    id: 2,
    name: "AlAqsa TV",
    description:
      "Al-Aqsa News TV website, a site that displays the contents of the channel, recordings shown live, reports, and broadcast schedules",
    tags: ["NextJs", "ReactJs", "Hooks", "REST-API", "SwiperJs"],

    demo: "https://alaqsa.nepras.ps/",
    github: "https://github.com/ahmedatif99",
  },
  {
    id: 3,
    name: "Discover Netflix Videos",
    description:
      "Discover Netflix Videos is an app to discover Netflix videos, see Videos trailer, see videos description, show the filme themselves, and add them to your own list.",
    tags: [
      "NextJs",
      "ReactJs",
      "Hooks",
      "Youtube-API",
      "GraphQl",
      "Magic web3-auth",
    ],

    demo: "https://discover-videos-gamma.vercel.app/",
    github: "https://github.com/ahmedatif99/Netflix-clone",
  },
  {
    id: 4,
    name: "Discover Coffee Stores",
    description:
      "Coffee Connoisseur is an app to discover the near coffee shops, find their addresses, see their ratings, and rate them.",
    tags: [
      "NextJs",
      "ReactJs",
      "Hooks",
      "Google-Map-API",
      "Airtable",
      "Airtable-API",
    ],

    demo: "https://find-coffee-shops.vercel.app/",
    github: "https://github.com/ahmedatif99/discover-coffee-stores",
  },
  {
    id: 5,
    name: "CRWN clothing E-commerce ",
    description:
      " E-commerce is a clothing store, that offers clothes, Hats, Sneakers, and Jackets for men and women that can be bought and delivered.",
    tags: ["React", "Redux", "StyledComponents", "Hooks", "Firebase"],

    demo: "https://crwn-clothing-tan-tau.vercel.app/",
    github: "https://github.com/ahmedatif99/crwn-clothing",
  },
  {
    id: 6,
    name: "Selat",
    description:
      "Landing page to the Selat for business solutions company, It is build on top of the Bootstrap-4. With nice style and full responsive.",
    tags: ["Html5", "Css3", "Bootstrap", "JS"],

    demo: "https://selat.resoos.com/",
    github: "https://selat.com.sa/",
  },
  {
    id: 7,
    name: "REST-Countries-API ",
    description:
      "It is build on top of the React JS, sass, . With realtime fetching of articles from dev.to using API, With searching and filtering functionalities.",
    tags: ["React", "API", "Sass"],

    demo: "https://rest-countries-api-ashen-ten.vercel.app/",
    github: "https://github.com/ahmedatif99/REST-Countries",
  },
  {
    id: 8,
    name: "Dashboard",
    description:
      "Admin Dashboard, build on top of the React JS, MUI. With dark and light theme switcher",
    tags: ["React", "MUI", "React-SideBar", "Yup", "Formik", "emotion", "nivo"],

    demo: "https://admin-dashboard-ahmedatif99.vercel.app/",
    github: "https://github.com/ahmedatif99/dashboard",
  },
  {
    id: 9,
    name: "Movie watchlist",
    description:
      "It is build on top of the React JS and context-api. With searching and filtering functionalities.",
    tags: ["React", "Context-API"],

    demo: "https://watchlist-pi.vercel.app/",
    github: "https://github.com/ahmedatif99/Watchlist",
  },
  {
    id: 10,
    name: "Tv-Show",
    description:
      "It is build on top of the React JS and context-api and StyledComponents. With searching and filtering functionalities.",
    tags: ["React", "Context-API", "StyledComponents"],

    demo: "https://ahmedatif-tv-show.netlify.app/",
    github: "https://github.com/ahmedatif99/tv-show",
  },
];

export const WorkBackendData = [
  {
    id: 1,
    name: "Airbnb Clone",
    description:
      "It is full stack web app clone build on top of Django for backend, with using many of django third party library as celere to add some functionality was important.",
    tags: [
      "Django",
      "rest-framework",
      "python3",
      "postman",
      "celery",
      "rest-auth",
      "ajax",
      "translation",
      "payment",
    ],

    demo: "http://ahmedatif99.pythonanywhere.com/",
    github: "https://github.com/ahmedatif99/Django-Airbnb-Clone",
  },
  {
    id: 2,
    name: "Meals Rater API ",
    description:
      "It is build on top of the Django using <rest-framework>, allow users or guests to rate the Meals of the resturents.",
    tags: ["Django", "rest-framework", "python3", "postman", "github"],

    demo: "http://ahmedatif.pythonanywhere.com/",
    github: "https://github.com/ahmedatif99/Meals_Rater_API",
  },
];
